import { type IncomingMessage, MessageHandler } from '@carvana/merch-native';
import { useMemo } from 'react';
import useAddFavoriteWithoutLogin from '~/hooks/srp/useAddFavoriteWithoutLogin';
import { ListenerEvent, type ListenerEventType } from './constants';

type AddFavoritePayload = {
  vehicleId: number;
};

function isAddFavoriteMessage(
  message: IncomingMessage<ListenerEventType, any>
): message is IncomingMessage<ListenerEventType, AddFavoritePayload> {
  return (
    message.event === ListenerEvent.AddFavorite &&
    message.payload.vehicleId != null
  );
}

export default function useAddFavoriteHandler(): MessageHandler<
  ListenerEventType,
  AddFavoritePayload
> {
  const addFavorite = useAddFavoriteWithoutLogin();

  return useMemo(
    () =>
      new MessageHandler(isAddFavoriteMessage, message => {
        void addFavorite(message.payload);
      }),
    [addFavorite]
  );
}
